import classes from "./Button.module.css";
import CustomIcon from "../CustomIcon/CustomIcon";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

function Button({
  label = "Test",
  type,
  backgroundColor = "#002970",
  color = "#FFFFFF",
  hasBorder = false,
  borderColor = "#002970",
  borderRadius = "100px",
  paddingLeft = 20,
  paddingRight = 20,
  paddingBottom = 12,
  paddingTop = 12,
  textTransform = "capitalize",
  width = "fit-content",
  className = "",
  id,
  disabled = false,
  labelClass = "",
  stylebtn = {},
  styleLabel = {},
  icon,
  iconWidth = 24,
  iconHeight = 24,
  iconPosition = "left",
  iconMarginLeft,
  iconMarginRight,
  iconMargin = 8,
  clickHandler ,
}) {
  return (
    <button
      className={`${classes.btn} ${className}`}
      style={{
        ...stylebtn,
        flexDirection: iconPosition === "left" ? "row" : "row-reverse",
        border: hasBorder ? `2px solid ${borderColor}` : "none",
        backgroundColor,
        width,
        borderRadius,
        paddingLeft,
        paddingRight,
        paddingBottom,
        paddingTop,
        cursor: "pointer",
        fontSize: "0.875rem",
        lineHeight: "1.3125rem",
        fontWeight: 600,
      }}
      onClick={clickHandler}
      id={id}
      disabled={disabled}
      type={type}
    >
      {icon && (
        <CustomIcon
          style={{
            width: iconWidth,
            height: iconHeight,
            marginLeft:
              iconPosition === "right"
                ? iconMargin
                : iconMarginLeft
                ? iconMarginLeft
                : "0",
            marginRight:
              iconPosition === "left"
                ? iconMargin
                : iconMarginRight
                ? iconMarginRight
                : "0",
          }}
          src={icon}
        />
      )}
      <div
        className={`${classes.btn} ${labelClass}`}
        style={{
          ...styleLabel,
          textTransform,
          color,
        }}
      >
        {label}
      </div>
    </button>
  );
}
export default Button;
